var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvasBox",style:(`
    height: ${_vm.canvasBoxHeight};
    width: ${_vm.canvasBoxWidth};`)},[_c('canvas',{attrs:{"id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }